import { DeviceWithStatus } from './device-with-status';

export class VehicleDevicesWithStatus {
    constructor(
      public sideNumber: string,
      public onDepot: boolean,
      public devices: DeviceWithStatus[]
    ) {}
}
